<div class="cell" [class.cell-pcr-change]="styleState==='pcr-change'" [class.cell-cancelled]="styleState==='cancelled'" [class.cell-state-2]="styleState==='state-2'">
  <div class="cell-header">
    <div class="load-number">{{ loadNumber }}</div>
    <button class="expand-btn" type="button" (click)="onToggleExpand()">
      <img src="/assets/images/Expand_Chevron.png" alt="Expand" class="expand-icon" [class.rotated]="isExpanded">
    </button>
  </div>

  <!-- Variety and Haulier with icons and divider -->
  <div class="meta-row">
    <img class="meta-icon" src="/assets/images/Plant_Variety.png" alt="Variety">
    <span class="meta-text variety">{{ (tags && tags.length > 0) ? (tags[0] || '') : '' }}</span>
    <span class="meta-sep" aria-hidden="true"></span>
    <img class="meta-icon" src="/assets/images/Truck.png" alt="Haulier">
    <span class="meta-text haulier">{{ (tags && tags.length > 1) ? (tags[1] || '') : '' }}</span>
  </div>

  <!-- Delivery/Planned rows -->
  <div class="info-section">
    <div class="sched-row">
      <img class="sched-icon" src="/assets/images/Calendar_Passport.png" alt="Calendar">
      <span class="sched-label">Scheduled Delivery - </span>
      <span class="sched-value">{{ scheduledText }}</span>
    </div>

    <ng-container *ngIf="showPlannedSection && styleState!=='cancelled'">
      <div class="separator"></div>

      <div class="planned-row">
        <button type="button" 
                class="planned-select" 
                (click)="openPlannedDatePicker()"
                [attr.aria-label]="'Select planned loading date. Current: ' + (plannedLoadingValue || 'Not set')">
          <span class="planned-label">Planned Loading - </span>
          <span class="planned-value">{{ plannedLoadingValue }}</span>
          <img class="chev" src="/assets/images/Chevron_Down_Blue.png" alt="Open">
          <label class="sr-only" [attr.for]="'planned-date-' + recordId">Planned loading date</label>
          <input #dateInput
                 [attr.id]="'planned-date-' + recordId"
                 type="datetime-local"
                 step="300"
                 class="planned-input"
                 (change)="onPlannedChange($event)"
                 [value]="plannedLoadingISO"
                 (click)="openPlannedDatePicker(); $event.stopPropagation()">
        </button>
        <button class="info-btn" type="button" (click)="showPlannedInfo(); $event.stopPropagation();" aria-label="Planned Loading info"><img class="info-icon" src="/assets/images/Info.png" alt="Info"></button>
      </div>

      <div class="info-banner" *ngIf="infoVisible">
        Planned Loading is exclusively for on farm planning purposes and will not influence haulage or scheduling times
      </div>
    </ng-container>
  </div>

  <div *ngIf="isExpanded" class="details">
    <app-passport-details [person]="{ passportID: recordId, vendorNumber: vendorNumber, origin: origin, destination: destination, apn: apn, apnName: apnName, vendorName: vendorName }" [mode]="'view'" (add)="openDetails()" (history)="openHistory()" (comments)="openComments()" [primaryLabel]="status==='pending' ? 'Add' : 'View'" [hideAdd]="styleState==='cancelled'" [hidePassportComplete]="true"></app-passport-details>
  </div>
</div>


